import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/query/keys'
import { useSession } from '@/features/auth/hooks/useSession'
import { resolveWorkspaceId } from '@/lib/workspace-routing'
import {
  fetchConversationSnapshot,
  fetchConversationsSnapshot,
} from '../lib/conversationAdapter'

export function useConversations(options?: {
  limit?: number
  cursor?: string
  visibility?: string
  tag?: string
}) {
  const { token, selectedContainer } = useSession()
  const workspaceId = resolveWorkspaceId(selectedContainer)

  return useQuery({
    queryKey: queryKeys.conversations.list({ workspaceId, ...options }),
    queryFn: () =>
      fetchConversationsSnapshot(token, workspaceId, {
        limit: options?.limit,
      }),
    enabled: !!token && !!workspaceId,
    staleTime: 30_000,
    placeholderData: (previousData) => previousData,
  })
}

export function useConversation(conversationId: string | null) {
  const { token, selectedContainer } = useSession()
  const workspaceId = resolveWorkspaceId(selectedContainer)

  return useQuery({
    queryKey: queryKeys.conversations.detail(conversationId || ''),
    queryFn: async () => {
      if (!conversationId) return null
      return await fetchConversationSnapshot(token, workspaceId, conversationId, {
        includeArchivedModules: true,
      })
    },
    enabled: !!conversationId && !!workspaceId,
    staleTime: 30_000,
  })
}

